export default __webpack_public_path__ + "static/media/saboratto.c681cf40.svg";